import React from 'react';

import { Avatar as ChakraAvatar } from '@chakra-ui/react';
import styled from '@emotion/styled';

import { isNetchexLogin } from 'constants/netChexConstants';

import { NotificationBadge } from 'uiToolkitV1/NotificationBadge';

const TransientProps = ['avatarSize'];

export const AVATAR_SIZES = [12, 16, 18, 24, 32, 40, 80, 84, 88, 120];

const StyledAvatar = styled(ChakraAvatar, {
  shouldForwardProp: (prop) => !TransientProps.includes(prop),
})(({ theme, ...props }) => ({
  height: `${props.avatarSize}px`,
  width: `${props.avatarSize}px`,
  background: isNetchexLogin ? '#2563eb' : null,
}));

const Avatar = ({
  name,
  src,
  size = AVATAR_SIZES[2],
  notificationCount = 0,
  transform = 'translate(10px, 0px)',
  ...props
}) => {
  if (!AVATAR_SIZES.includes(size)) {
    console.error(`Invalid avatar size using ${AVATAR_SIZES[2]} as default.
    Please provide any of ${AVATAR_SIZES} or add the new size and then use`);
    size = AVATAR_SIZES[2];
  }

  // eslint-disable-next-line no-nested-ternary
  const numericSize = +size;
  let dynamicFontSize = null;
  if (numericSize <= 18) {
    dynamicFontSize = '8px !important';
  } else if (numericSize <= 32) {
    dynamicFontSize = '10px !important';
  } else {
    dynamicFontSize = null; // optional, for clarity
  }

  if (!isNetchexLogin) {
    dynamicFontSize = null;
  }
  const sxStyles = dynamicFontSize
    ? {
        'div[role="img"]': {
          fontSize: dynamicFontSize,
        },
      }
    : {};

  return (
    <NotificationBadge notificationCount={notificationCount} transform={transform}>
      <StyledAvatar
        avatarSize={size}
        name={name}
        src={src}
        {...props}
        sx={props.sx ? { ...props.sx, ...sxStyles } : sxStyles}
      />
    </NotificationBadge>
  );
};

export { Avatar };
